<template>
    <div>
        <el-form-item
                label="1. Justificación de la necesidad"
                prop="explanation"
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }">
            <el-input v-model="requestForm.explanation"
                      type="textarea"
                      :rows="10"
                      :disabled="onlyRead== true ? true: false"
                      placeholder="Describir las razones por las cuales la Representación opta por llevar a cabo un arrendamiento en vez de una adquisición, o viceversa. Además, deberán justificar la necesidad del servicio o bien a contratar o adquirir, señalando las actividades en las que será utilizado, así como las consecuencias de no contar con el servicio o arrendamiento solicitado.

 Si se trata de ADQUISICIÓN, integrar además la siguiente información:
• Dirección de la RME
• Coordenadas geográficas (en decimales)
• Plano de la Representación donde se muestre la ubicación donde será(n) colocado(s) el(los) bien(es)
• Fotografías de los bienes a sustituir y los espacios donde serán colocados.

Nota: Es obligatorio realizar la una comparativa que muestre el beneficio económico que se logrará al elegir la opción de arrendamiento o bien la adquisición. Esta selección deberá sustentarse ampliamente."/>
        </el-form-item>

        <div class="el-table__header-wrapper el-table__body-wrapper is-scroll-left">
            <table border="1" class="el-table__header custom-lock" style="width: 100%">
                <thead class="is-group has-gutter">
                <tr>
                    <th rowspan="2" style="text-align: center">
                        Concepto
                    </th>
                    <th colspan="3" style="text-align: center">
                        Cotizaciones
                    </th>
                </tr>
                <tr>
                    <th v-for="(item , key) in requestForm.providers" :key="key+'_a'" style="text-align: center">
                        Proveedor {{key+1}}
                    </th>
                </tr>
                </thead>
                <tbody class="el-table__body">
                <tr v-for="(item , key) in general.providersAlias.format" :key="key+'_b'">
                    <td>
                        {{ item.concept}}
                    </td>
                    <td v-for="(item2 , key2) in requestForm.providers" :key="key2+'_d'">

                        <el-form-item label="" v-if="item.type =='1'"
                                      :required="isRequired(key2)"
                                      :prop="'providers[' + key2 + '].name'"
                                      :rules="{ required: isRequired(key2), message: 'El campo es requerido',trigger: ['blur','change'] }">
                            <el-input v-model="item2.name" :disabled="onlyRead== true ? true: false"
                                      placeholder="Escriba el nombre del proveedor"/>
                        </el-form-item>


                        <el-form-item label="" v-if="item.type =='2'"
                                      :required="isRequired(key2)"
                                      :prop="'providers[' + key2 + '].monthlyAgreementValidity'"
                                      :rules="{ required: isRequired(key2), message: 'El campo es requerido',trigger: ['blur','change'] }">


                            <el-input-number v-model="item2.monthlyAgreementValidity"
                                             :disabled="onlyRead== true ? true: false" :min="0"
                                             style="width: 100%"/>
                        </el-form-item>
                        <el-form-item label="" v-if="item.type == 3"
                                      :required="isRequired(key2)"
                                      :prop="'providers[' + key2 + '].proposedStartDate'"
                                      :rules="{ required: isRequired(key2), message: 'El campo es requerido',trigger: ['blur','change'] }">
                            <el-date-picker
                                    :picker-options="pickerOptions"
                                    type="date"
                                    style="width: 100%"
                                    :disabled="onlyRead== true ? true: false"
                                    format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"
                                    v-model="item2.proposedStartDate">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="" v-if="item.type == 4"
                                      :required="isRequired(key2)"
                                      :prop="'providers[' + key2 + '].paymentCurrency'"
                                      :rules="{ required: isRequired(key2), message: 'El campo es requerido',trigger: ['blur','change'] }">

                            <el-select v-model="item2.paymentCurrency"
                                       :disabled="onlyRead== true ? true: false"
                                       style="width: 100%"
                                       filterable clearable
                                       placeholder="Seleccionar">
                                <el-option
                                        v-for="item in catalogs.catCurrencies"
                                        :key="item.id"
                                        :label="item.name+' '+item.code"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" v-if="item.type == 5"
                                      :required="isRequired(key2)"
                                      :prop="'providers[' + key2 + '].payment_periodicity_id'"
                                      :rules="{ required: isRequired(key2), message: 'El campo es requerido',trigger: ['blur','change'] }">


                            <el-select v-model="item2.payment_periodicity_id"
                                       :disabled="onlyRead== true || key2 == 1 ||  key2 == 2 ? true: false"
                                       @change="changePeriodicity(item2.payment_periodicity_id)"
                                       style="width: 100%"
                                       filterable clearable
                                       placeholder="Seleccionar">
                                <el-option
                                        v-for="item in catalogs.catPaymentPeriodicity"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>

                        </el-form-item>
                        <el-form-item label="" v-if="item.type == 6"
                                      :required="isRequired(key2)"
                                      :prop="'providers[' + key2 + '].monthlyCostWithTaxes'"
                                      :rules="{ required: isRequired(key2), message: 'El campo es requerido',trigger: ['blur','change'] }">


                            <vue-numeric currency="$"
                                         :disabled="onlyRead== true ? true: false"
                                         class="el-input__inner"
                                         separator=","
                                         v-model="item2.monthlyCostWithTaxes"
                                         :max="1000000000"
                                         :precision="2"
                            ></vue-numeric>


                        </el-form-item>
                        <el-form-item label="" v-if="item.type == 7"
                                      :required="isRequired(key2)"
                                      :prop="'providers[' + key2 + '].carrierExpenses'"
                                      :rules="{ required: isRequired(key2), message: 'El campo es requerido',trigger: ['blur','change'] }">

                            <vue-numeric currency="$"
                                         :disabled="onlyRead== true ? true: false"
                                         class="el-input__inner"
                                         separator=","
                                         v-model="item2.carrierExpenses"
                                         :max="1000000000"
                                         :precision="2"
                            ></vue-numeric>


                        </el-form-item>
                        <el-form-item label="" v-if="item.type == 8">

                            <el-input-number v-model="item2.anotherExpensesAux" :precision="2"
                                             :disabled="onlyRead== true ? true: false"
                                             :step="1" :min="0" style="width: 100%"/>
                        </el-form-item>
                        <el-form-item label="" v-if="item.type == 9">

                            <vue-numeric currency="$"
                                         :disabled="onlyRead== true ? true: false"
                                         class="el-input__inner"
                                         separator=","
                                         v-model="item2.instalmentCosts"
                                         :max="1000000000"
                                         :precision="2"
                            ></vue-numeric>


                        </el-form-item>
                        <el-form-item label="" v-if="item.type == 10">

                            <vue-numeric currency="$"
                                         :disabled="onlyRead== true ? true: false"
                                         class="el-input__inner"
                                         separator=","
                                         v-model="item2.anotherExpenses"
                                         :max="1000000000"
                                         :precision="2"
                            ></vue-numeric>


                        </el-form-item>
                    </td>
                </tr>
                <tr>
                    <td style="font-weight: bold;background: #c9c9c9c9">
                        SUBTOTAL
                    </td>
                    <td style="font-weight: bold;background: #c9c9c9c9; text-align: center"
                        v-for="(item2) in requestForm.providers"
                        v-if="item2.monthlyCostWithTaxes > 0 || item2.carrierExpenses > 0 || item2.instalmentCosts > 0">
                        ${{ sumaX(item2) }}
                    </td>
                    <td v-else style="font-weight: bold;background: #c9c9c9c9; text-align: center">
                        $0.0
                    </td>
                </tr>
                <tr>
                    <td style="font-weight: bold;background: #c9c9c9c9">
                        TOTAL
                    </td>
                    <td style="font-weight: bold;background: #c9c9c9c9;text-align: center"
                        v-for="(item2) in requestForm.providers"
                        v-if="item2.monthlyCostWithTaxes > 0 || item2.carrierExpenses > 0 || item2.instalmentCosts> 0 ">
                        ${{ sumaY(item2) }}
                    </td>
                    <td v-else style="font-weight: bold;background: #c9c9c9c9; text-align: center">
                        $0.0
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <br>

        <div class="el-table__header-wrapper el-table__body-wrapper is-scroll-left" style="overflow: auto">
            <table border="1" class="el-table__header custom-lock">
                <thead class="is-group has-gutter">
                <tr>
                    <th>

                    </th>
                    <th v-for="(item , key) in requestForm.providers" :key="key+'_e'" style="text-align: center">
                        Proveedor {{key+1}}
                    </th>
                </tr>
                </thead>
                <tbody class="el-table__body">
                <tr v-for="(item , key) in general.providersAliasTwo.format" :key="key+'_f'">
                    <td>
                        {{ item.concept}}
                    </td>
                    <td v-for="(item2 , key2) in requestForm.providers" :key="key2+'_g'">
                        <el-form-item label="" v-if="item.type == 11">
                            <el-input v-model="item2.quantity" :disabled="true"/>
                        </el-form-item>
                        <el-form-item v-if="item.type == 12" label="">


                            <el-select
                                    style="width:100%"
                                    :disabled="true"
                                    v-model="item2.equipment_types_ids"
                                    filterable
                                    multiple
                                    placeholder="Seleccionar">
                                <el-option
                                        v-for="item in catalogs.catEquipmentTypes"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>

                        </el-form-item>
                        <el-form-item v-if="item.type == 13" label="">
                            <div align="center">



                                <el-switch
                                        :disabled="onlyRead== true ? true: false"
                                        style="display: block"
                                        v-model="item2.quotedPriceIsFixed"
                                        active-color="#13ce66"
                                        active-text="Sí"
                                        inactive-text="No">
                                </el-switch>


                            </div>

                        </el-form-item>
                        <el-form-item v-if="item.type == 14">
                            <div align="center">


                                <el-switch
                                        :disabled="onlyRead== true ? true: false"
                                        style="display: block"
                                        v-model="item2.payInAdvance"
                                        active-color="#13ce66"
                                        active-text="Sí"
                                        inactive-text="No">
                                </el-switch>



                            </div>

                        </el-form-item>
                        <el-form-item v-if="item.type == 15" label="">
                            <el-input v-model="item2.providerGuarantees" :disabled="onlyRead== true ? true: false"/>
                        </el-form-item>
                        <el-form-item v-if="item.type == 16">
                            <el-input v-model="item2.penalties" :disabled="onlyRead== true ? true: false"/>
                        </el-form-item>
                        <el-form-item v-if="item.type == 17">

                            <DocsProvider :onlyRead="onlyRead" :item="item2">
                            </DocsProvider>

                        </el-form-item>

                    </td>
                </tr>

                </tbody>
            </table>
        </div>
        <el-form-item label="Justificación de la selección del Proveedor seleccionado">
            <el-input type="textarea" :rows="10" v-model="requestForm.justification2"
                      :disabled="onlyRead== true ? true: false"/>
        </el-form-item>
        <br>
        <el-form-item>
            <el-input type="textarea" :rows="10" v-model="requestForm.provider_selected.justification"
                      :disabled="true"/>
        </el-form-item>


        <showButtonPdf :type="2" label="Descargar Investigación de Mercado"/>

        <Docs :onlyRead="onlyRead" :sectionId="6">
            <div class="tip" style="padding: 35px;" slot="main">
                Suba su documento firmado Investigación de Mercado
            </div>
        </Docs>


    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
    import Docs from '@/components/views/acquisition/partials/Docs'
    import showButtonPdf from '@/components/views/acquisition/partials/showButtonPdf'
    import DocsProvider from '@/components/views/acquisition/partials/DocsProvider'

    export default {

        components: {
            showButtonPdf,
            Docs,
            DocsProvider
        },
        computed: {
            ...mapGetters("form", {
                requestForm: "requestForm",
                catalogs: "catalogs",
                general: "general",
                onlyRead: "onlyRead"
            }),
            ...mapGetters(["userInfo"]),
            difficultLifeTypeAndHealthWeek(){
                return this.userInfo && this.userInfo.office ?  this.userInfo.office.isHardLife : false;
            }
        },

        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        let yesterday = moment().subtract(1, 'day');
                        return time.getTime() < yesterday;
                    }
                }
            }
        },
        methods: {
            ...mapMutations('form', {
                setExplanation: "setExplanation",
                setChangePeriodicity: "setChangePeriodicity"
            }),
            sumaX(item2) {
                let _a = parseFloat(item2.monthlyCostWithTaxes);
                let _b = parseFloat(item2.carrierExpenses);
                let _c = parseFloat(item2.instalmentCosts);
                if(_a >= 0 || _b >= 0 || _c >= 0){
                    let suma = _a + _b + _c;
                    if (isNaN(suma) || suma == '' || !suma) return 0;

                    try {
                        return suma.toFixed(2);
                    } catch (err) {
                        return suma;
                    }
                }

            },

            sumaY(item2) {
                let _a = parseFloat(item2.monthlyCostWithTaxes);
                let _b = parseFloat(item2.carrierExpenses);
                let _c = parseFloat(item2.instalmentCosts);
                let _d = parseFloat(item2.anotherExpenses);

                let suma = _a + _b + _c + _d;

                if (isNaN(suma) || suma == '' || !suma) return 0;

                try {
                    return suma.toFixed(2);
                } catch (err) {
                    return suma;
                }
            },

            isRequired(key) {
                if (this.difficultLifeTypeAndHealthWeek == true || this.difficultLifeTypeAndHealthWeek == 1) {
                    if (key == 0) {
                        return true;
                    }
                    return false;
                }
                return true;
            },
            changePeriodicity(payload){
                this.setChangePeriodicity(payload);
            }
        },
        watch: {

            'requestForm.explanation'() {

            }
        }


    }
</script>

<style scoped>

</style>
